<template>
  <div class="userListPage">
    <section>
      <header>
        <el-tabs v-model="data.is_transient" @tab-click="handleClick">
          <el-tab-pane :label="$t('message.allPersonnel')" name=""></el-tab-pane><!--    全部人员-->
          <el-tab-pane :label="$t('message.permanentWorker')" name="正式"></el-tab-pane><!--正式工-->
          <el-tab-pane :label="$t('message.temporaryWorker')" name="临时"></el-tab-pane><!--临时工-->
        </el-tabs>
        <div class="flexAndCenter">
          <!-- 设置默认封箱人：对勾选的配货账号逐个设置。 -->
          <el-button size="small" type="primary" class="secondary" @click="openDefaultSealer" v-if="isAuth(778)">
            {{ $t('message.setDefaultSealer') }}
          </el-button>
          <!-- 下单地址设置 -->
          <el-button size="small" type="primary" class="secondary" @click="showDialogVisible" v-if="isAuth(125)">{{
            $t("message.orderAddressSetting") }}</el-button>
          <!--成员添加-->
          <el-button size="small" type="primary" @click="$router.push('addUser')" v-if="isAuth(122)">{{
            $t("message.addMembers")
          }}</el-button>
        </div>
      </header>
      <div class="operationContainer flexAndCenter">
        <div class="flexAndCenter operationLeftContainer">
          <div>
            <el-cascader :options="organizationData" :props="{
              checkStrictly: true,
              label: 'name',
              children: 'childs',
              expandTrigger: 'hover',
              value: 'id',
            }" clearable :placeholder="$t('message.scopeOfPersonnel')" @change="getValue" />
            <!--人员范围-->
          </div>
          <div>
            <el-select v-model="data.work_type" :placeholder="$t('message.typeOfWork')"><!--工种-->
              <el-option v-for="item in worktypeData" :key="item.id" :label="item.work_name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div>
            <el-input v-model="data.username" :placeholder="$t('message.systemAccount')" />
          </div>
          <!--系统账号-->
          <div>
            <el-input v-model="data.realname" :placeholder="$t('message.name')" />
          </div>
          <!--姓名-->
          <div>
            <el-input v-model="data.mobile" :placeholder="$t('message.phoneNumber')" />
          </div>
          <!--手机号-->
          <div>
            <el-input v-model="data.id" :placeholder="$t('message.employeeId')" />
          </div>
          <!--员工ID-->
          <div style="margin-right: 0">
            <el-select v-model="data.is_forbid"><!--工种-->
              <el-option label="全部" value="">
              </el-option>
              <el-option label="启用" value="0">
              </el-option>
              <el-option label="停用" value="1">
              </el-option>
            </el-select>
          </div>
          <!--员工ID-->

        </div>
        <div class="flexAndCenter">
          <el-button @click="search" type="primary" style="margin-left:20px">{{ $t("message.search")
          }}</el-button><!--搜索-->
          <el-button @click="reset">{{ $t("message.reset") }}</el-button><!--重置-->
        </div>
      </div>
      <div class="table">
        <el-table :data="accountNumberList" style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column type="index" label="NO" align="center">
          </el-table-column>
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <!--      系统账号-->
          <el-table-column prop="username" :label="$t('message.systemAccount')" align="center">
            <template v-slot="scope">
              <div v-if="scope.row.is_transient === 1" style="color: #15ad3c">
                临时工
              </div>
              <div v-else>正式员工</div>
              <p>{{ scope.row.username }}</p>
              <p>{{ scope.row.realname }}</p>
            </template>
          </el-table-column>
          <!--      性别-->
          <el-table-column :label="$t('message.sex')" align="center">
            <template v-slot="scope">
              <div>{{ scope.row.sex === 1 ? "男" : "女" }}</div>
            </template>
          </el-table-column>
          <!--      电话-->
          <el-table-column prop="mobile" :label="$t('message.phone')" align="center">
          </el-table-column>
          <!--      聊天显示名称-->
          <el-table-column prop="im_nick" :label="$t('message.chatDisplayName')" align="center">
          </el-table-column>
          <!--      聊天群组-->
          <el-table-column :label="$t('message.chatGroup')" align="center">
            <template v-slot="scope">
              <div>
                <div v-for="(item, index) in scope.row.role" :key="index">
                  {{
                    item.auto_chat
                      ? $t("message.automaticallyAdd")
                      : $t("message.notAutomaticallyAdded")
                  }}
                </div>
                <!-- 特殊加群 -->
                <el-button size="mini" type="primary" class="primary" @click="specialGroupAddition(scope.row)">
                  CW{{ $t('message.specialGroupAddition') }}
                </el-button>
              </div>
            </template>
          </el-table-column>
          <!--  角色-->
          <el-table-column :label="$t('message.role')" align="center">
            <template v-slot="scope">
              <div>
                <div v-for="(item, index) in scope.row.role" :key="index">
                  {{ item.name }}
                </div>
              </div>
            </template>
          </el-table-column>
          <!--  自动下单前缀-->
          <el-table-column :label="$t('message.automaticSinglePrefix')" align="center">
            <template v-slot="scope">
              <div v-if="scope.row.admin_order_address_model !== null">
                {{ scope.row.admin_order_address_model.receiver_prefix }}
              </div>
              <!-- 无关联时不展示；已关联但禁用的账号仍保留姓名，反映当前设置。 -->
              <p v-if="scope.row.default_sealer" class="default-sealer">
                {{ $t('message.defaultSealer') }}：{{ scope.row.default_sealer.realname }}
              </p>
            </template>
          </el-table-column>
          <!--  自动下单自定义部分-->
          <el-table-column :label="$t('message.automaticallyOrderCustomParts')" width="160" align="center">
            <template v-slot="scope">
              <div v-if="scope.row.admin_order_address_model !== null">
                {{ scope.row.admin_order_address_model.receiver_address }}
              </div>
            </template>
          </el-table-column>
          <!--  可进入子系统设置-->
          <el-table-column :label="$t('message.youCanEnterSubsystemSettings')" width="160" align="center">
            <template v-slot="scope">
              <div>
                <el-button v-for="(item, index) in scope.row.admin_system" :key="index" size="mini" class="primary">{{
                  item.system_name }}</el-button>
              </div>
            </template>
          </el-table-column>
          <!--  对应跟进人员-->
          <el-table-column :label="$t('message.correspondingFollowUpPersonnel')" width="160" align="center">
            <template v-slot="scope">
              <div>
                <div v-for="(item, index) in scope.row.follow_config" :key="index">
                  <div v-for="(items, indexs) in item.rate" :key="indexs">
                    <p v-if="item.is_usable">

                      {{ getName(items.admin_id) }}
                    </p>
                  </div>
                </div>
                <el-button size="mini" class="primary" @click="personnelConfiguration(scope.row)" v-if="isAuth(604)">
                  {{ $t('message.personnelConfiguration') }}</el-button>
              </div>
            </template>
          </el-table-column>
          <!--账号状态-->
          <el-table-column :label="$t('message.accountStatus')" align="center">
            <template v-slot="scope">
              <el-switch v-model="scope.row.forbid_login" active-color="#2C96E7" :active-value="0"
                :disabled="!isAuth(126)" @change="updateAccountNumberChange(scope.row, scope.$index)"
                :inactive-value="1" inactive-color="#DCDFE6">
              </el-switch>
            </template>
          </el-table-column>
          <!--操作-->
          <el-table-column label="操作" align="center">
            <template v-slot="scope">
              <el-button size="mini" @click="accountNumberEdit(scope.row)" class="primary" v-if="isAuth(123)">{{
                $t("message.accountToEdit") }}</el-button><!--账号编辑-->
              <el-button size="mini" @click="editUserRolePageJump(scope.row)"
                style="background: #333333; color: #fff; margin-top: 5px;margin-left: 0" v-if="isAuth(124)">{{
                  $t("message.editRole")
                }}</el-button><!--角色编辑-->
              <!--  -->
              <p v-if="scope.row.isJinPin && isAuth(127)" style="margin-top: 5px;">
                <el-button size="mini" @click="showJinPinDialogVisible(scope.row)" type="success">{{
                  $t("message.checkProductAttributes") }}</el-button><!--检品属性-->
              </p>
              <!-- 下单前缀设置 -->
              <p style="margin-top: 5px;">
                <el-button size="mini" @click="showPrefix(scope.row, $t('message.orderPrefixSetting'), 1)"
                  type="success" class="primary">{{
                    $t("message.orderPrefixSetting") }}</el-button>
              </p>
              <!-- 下单手机设置 -->
              <p style="margin-top: 5px;">
                <el-button size="mini" @click="showPrefix(scope.row, $t('message.orderPhoneSettings'), 2)"
                  type="success" class="primary">{{
                    $t("message.orderPhoneSettings") }}</el-button>
              </p>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="data.page"
          :page-sizes="[10, 20, 30, 40]" :page-size="data.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </section>
    <set-default-sealer-dialog ref="setDefaultSealerDialog" :can-set="isAuth(778)" @saved="getAccountNumberList" />
    <!-- 自动下单收件人前缀： -->
    <el-dialog :title="prefixTitle" :close-on-click-modal="false" :visible.sync="prefixDialogVisible" width="570px"
      center>
      <div class="row" v-if="prefixType == 1">
        <div class="label">{{ $t("message.automaticSinglePrefix") }}</div>
        <el-input v-model="prefixData.receiver_prefix"></el-input>
      </div>
      <!-- 收件人手机号: -->
      <div class="row" v-if="prefixType == 2">
        <div class="label">
          {{ $t("message.recipientSMobileNumber") }}
        </div>
        <el-input v-model="prefixData.receiver_mobile"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 保存 -->
        <el-button type="primary" @click="setAutoOrderPrefixAndMobile">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 自动下单信息设置 -->
    <el-dialog :title="$t('message.orderAddressSetting')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="570px" center>
      <!-- 自动下单自定义部分 -->
      <div class="label" style="margin-top: 20px">
        {{ $t("message.automaticallyOrderCustomParts") }}
      </div>
      <el-input v-model="autoOrderAddressData.receiver_address" type="textarea"></el-input>
      <span slot="footer" class="dialog-footer">
        <!-- 保存 -->
        <el-button type="primary" @click="setAutoOrderAddress">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 检品属性配置 -->
    <el-dialog :title="$t('message.configurationOfInspectionProperties')" :close-on-click-modal="false"
      :visible.sync="jinPinDialogVisible" width="930px" center>
      <div class="attributeList">
        <el-table :data="attributeList" style="width: 100%" border
          :header-cell-style="{ background: '#EDEFF4', color: '#333' }">
          <!-- 角色 -->
          <el-table-column :label="$t('message.role')" align="center" width="270" prop="name">
          </el-table-column>
          <el-table-column :label="$t('message.checkProductAttributes')" align="center">
            <template slot-scope="scope">
              <div class="row">
                <div class="items">
                  {{ $t("message.checkProductAttributes") }}
                </div>
                <div class="items">
                  <el-checkbox v-model="scope.row.enable_normal_inspect">普通检品</el-checkbox>
                </div>
                <div class="items">
                  <el-checkbox v-model="scope.row.enable_careful_inspect">精细检品</el-checkbox>
                </div>
                <div class="items">
                  <el-checkbox v-model="scope.row.enable_label">布标处理</el-checkbox>
                </div>
                <div class="items">
                  <el-checkbox v-model="scope.row.enable_fba">FBA</el-checkbox>
                </div>
              </div>
              <div class="row">
                <div class="items">
                  {{ $t("message.allocationProportion") }}
                </div>
                <div class="items">
                  <el-input v-model="scope.row.normal_inspect_rate" size="mini" type="number"></el-input>
                </div>
                <div class="items">
                  <el-input v-model="scope.row.careful_inspect_rate" size="mini" type="number"></el-input>
                </div>
                <div class="items">
                  <el-input v-model="scope.row.label_rate" size="mini" type="number"></el-input>
                </div>
                <div class="items">
                  <el-input v-model="scope.row.fba_rate" size="mini" type="number"></el-input>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 保存 -->
        <el-button type="primary" @click="setInspectRate">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 人员配置设置 -->
    <el-dialog :title="$t('message.personnelConfigurationSettings')" :close-on-click-modal="false"
      :visible.sync="personnelConfigurationDialogVisible" width="1000px" center>
      <div class="btn">
        <!-- 新增 -->
        <el-button type="success" size="mini" @click="addSetFollower"> {{ $t('message.add') }}</el-button>
      </div>
      <div class="table">
        <ol>
          <li style="flex:0.5">NO</li>
          <!-- 生效时间 -->
          <li class="flex2">{{ $t('message.effectiveTime') }}</li>
          <!-- 跟进人员 -->
          <li class="flex2">{{ $t('message.followUpPersonnel') }}</li>
          <!-- 比例 -->
          <li>{{ $t('message.proportion') }}</li>
          <!-- 操作 -->
          <li style="flex:0.5">{{ $t('message.operation') }}</li>
        </ol>
        <ul v-for="(item, index) in setFollowerData.list" :key="index">
          <li style="flex:0.5">{{ index + 1 }}</li>
          <!-- 生效时间 -->
          <li class="flex2">
            <div>
              开始: <el-date-picker v-model="item.start_at" type="datetime" placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
              <p style="margin-top: 10px;">结束: <el-date-picker v-model="item.end_at" type="datetime"
                  placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss" default-time="['23:59:59']">
                </el-date-picker>
              </p>
            </div>
          </li>
          <!-- 跟进人员 -->
          <li class="flex2">
            <el-select v-model="item.userList" clearable filterable :placeholder="$t('message.salesman')" multiple
              @change="setRate(index)">
              <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </li>
          <!-- 比例 -->
          <li class="flex2">
            <div class="rate">
              <div class="row" v-for="(items, indexs) in item.rate" :key="indexs">
                <span>%</span>
                <div class="name">{{ getName(items.admin_id) }}</div>
                <el-input-number v-model="items.rate" type="number" :max="100"
                  controls-position="right"></el-input-number>
              </div>
            </div>
          </li>
          <!-- 操作 -->
          <li style="flex:0.5">
            <el-button type="danger" size="mini" @click="setFollowerData.list.splice(index, 1)"> {{ $t('message.delete')
            }}</el-button>
          </li>
        </ul>
      </div>

      <span slot="footer" class="dialog-footer">
        <!-- 保存 -->
        <el-button type="primary" @click="setFollower" v-if="isAuth(605)">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- CW特殊加群 -->
    <el-dialog :title="'CW' + $t('message.specialGroupAddition')" :close-on-click-modal="false"
      :visible.sync="specialGroupAdditionDialogVisible" width="600px" center>
      <el-select v-model="bindFoundRelationData.relevance" clearable filterable :placeholder="$t('message.salesman')"
        multiple style="width: 100%;">
        <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <!-- 保存 -->
        <el-button type="primary" @click="bindFoundRelation">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 账号状态不登录 -->
    <el-dialog title="提示" :close-on-click-modal="false" :visible.sync="forbidLoginDialogVisible" width="600px" center
      @closed="handleDialogClose">
      <div class="forbidLoginData">
        <div class="title">
          {{ forbidLoginData.message }}
        </div>
        <div class="text">
          <p v-for="(item, index) in forbidLoginData.list" :key="index">
            {{ item }}
          </p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 保存 -->
        <el-button type="primary" @click="updateUserForbidLogin(updateUserForbidData)">确认关闭账号</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import setDefaultSealerDialog from './components/setDefaultSealerDialog'
export default {
  name: "index",
  components: { setDefaultSealerDialog },
  computed: {

    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },
  },
  data() {
    return {

      dialogVisible: false,
      jinPinDialogVisible: false,
      activeName: "",
      organizationData: [],
      accountNumberList: [],
      input: "",
      worktypeData: [],
      data: {
        is_transient: "",
        username: "",
        realname: "",
        mobile: "",
        id: "",
        org_id: "",
        work_type: "",
        is_forbid: '0',
        page: 1,
        pageSize: 10,
      },
      total: 0,
      autoOrderAddressData: {},
      multipleSelection: [],
      attributeList: [],
      admin_inspect_config: {},
      val: "",
      checked: false,
      // 前缀设置
      prefixData: {},
      prefixDialogVisible: false,
      prefixTitle: '',
      prefixType: '',
      //人员跟进
      personnelConfigurationDialogVisible: false,
      setFollowerData: {
        admin_id: '',
        list: [],
      },// 设置跟进数据
      //  CW特殊加群 
      specialGroupAdditionDialogVisible: false,
      bindFoundRelationData: {
        admin_id: '',
        relevance: []
      },
      forbidLoginData: {},//账户关闭提示数据
      forbidLoginDialogVisible: false,
      updateUserForbidData: {},
      index: 0,
    };
  },
  created() {
    this.getAccountNumberList();
    this.getOrganizationList();
    this.getWorktypeList();
  },
  methods: {
    openDefaultSealer() {
      if (!this.isAuth(778)) return
      this.$refs.setDefaultSealerDialog.open(this.multipleSelection)
    },
    handleClick(tab, event) {
      this.data.page = 1;
      this.getAccountNumberList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //账号列表数据获取
    getAccountNumberList() {
      this.$api.roleApi.accountNumberList(this.data).then((res) => {
        res.data.data.forEach((item) => {
          item.isJinPin = item.role.some((items) => items.work_type == 6);
        });
        this.accountNumberList = res.data.data;
        this.total = res.data.total;
      });
    },
    //工种类型获取
    getWorktypeList() {
      this.$api.roleApi.worktypeList().then((res) => {
        this.worktypeData = res.data;
      });
    },
    //角色编辑页面跳转
    editUserRolePageJump(item) {
      this.$router.push({
        name: "editUserRole",
        query: {
          id: item.id,
        },
      });
    },
    //编辑账号信息
    accountNumberEdit(item) {
      this.$router.push({
        name: "addUser",
        query: {
          id: item.id,
        },
      });
    },
    //更新页数
    handleCurrentChange(val) {
      this.data.page = val;
      this.getAccountNumberList();
    },
    //更新分页每页数量
    handleSizeChange(val) {
      this.data.pageSize = val;
      this.getAccountNumberList();
    },
    // 搜索
    search() {
      this.data.page = 1;
      this.getAccountNumberList();
    },
    //重置
    reset() {
      this.data = {
        is_transient: "",
        username: "",
        realname: "",
        mobile: "",
        id: "",
        org_id: "",
        work_type: "",
        is_forbid: '0',
        page: 1,
        pageSize: 10,
      };
      this.getAccountNumberList();
    },
    //更新上级目录
    getValue(e) {
      this.data.org_id = e[e.length - 1];
    },
    //设置账号开启或关闭
    updateAccountNumberChange(item, index) {
      this.index = index
      this.updateUserForbidData = item
      if (item.forbid_login) {
        this.$api.roleApi
          .forbidLoginCheck({
            id: item.id
          })
          .then((res) => {
            if (res.data.status) {
              this.updateUserForbidLogin(item)
            } else {
              this.forbidLoginData = res.data
              this.forbidLoginDialogVisible = true
            }
          });
      } else {
        this.updateUserForbidLogin(item)
      }
    },
    //  账号设置为启用状态 设置为停用状态
    updateUserForbidLogin(item) {
      //是否将此账号设置为启用状态    是否将此账号设置为停用状态                               提示
      this.$confirm(
        item.forbid_login === 0
          ? this.$t("message.whetherToEnableTheAccount")
          : this.$t("message.whetherToDisableTheAccount"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.confirm"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.roleApi
            .updateUserForbidLogin({
              id: item.id,
              forbid_login: item.forbid_login,
            })
            .then((res) => {
              this.$message.success(res.msg);
              this.forbidLoginDialogVisible = false
              this.getAccountNumberList();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("message.theSettingsHaveBeenCancelled"), //已取消回退
          });
        });
    },
    //取消操作关闭账号
    handleDialogClose() {
      this.getAccountNumberList();
    },
    //人员范围获取
    getOrganizationList() {
      this.$api.roleApi.organizationList().then((res) => {
        this.organizationData = res.data;
      });
    },
    // 显示自动下单地址弹窗
    showDialogVisible() {
      if (this.multipleSelection == false)
        return this.$t("message.notToChoose");
      this.autoOrderAddressData = {
        ids: [],
        receiver_address: "",
      };
      this.multipleSelection.forEach((item) => {
        this.autoOrderAddressData.ids.push(item.id);
      });
      this.dialogVisible = true;
    },
    //账号-自动下单地址设置
    setAutoOrderAddress() {
      this.$api.roleApi
        .setAutoOrderAddress(this.autoOrderAddressData)
        .then((res) => {
          this.$message.success(res.msg);
          this.getAccountNumberList();
          this.dialogVisible = false;
        });
    },
    // 显示精品属性设置
    showJinPinDialogVisible(item) {
      // console.log(item);
      this.attributeList = [];
      item.role.forEach((items) => {
        if (items.work_type == 6) {
          if (items.inspect_config) {
            items.inspect_config.role_id = items.id;
            items.inspect_config.name = items.name;
            this.attributeList.push(items.inspect_config);
          } else {
            this.attributeList.push({
              admin_id: item.id,
              role_id: items.id,
              name: items.name,
              enable_normal_inspect: false,
              enable_careful_inspect: false,
              enable_label: false,
              enable_fba: false,
              normal_inspect_rate: "",
              careful_inspect_rate: "",
              label_rate: "",
              fba_rate: "",
            });
          }
        }
      });

      this.$forceUpdate();
      this.jinPinDialogVisible = true;
    },
    // 账号-检品属性设置(批量
    setInspectRate() {
      let datas = {
        list: [],
      };
      this.attributeList.forEach((item) => {
        datas.list.push({
          admin_id: item.admin_id,
          role_id: item.role_id,
          enable_normal_inspect: item.enable_normal_inspect ? 1 : 0,
          enable_careful_inspect: item.enable_careful_inspect ? 1 : 0,
          enable_label: item.enable_label ? 1 : 0,
          enable_fba: item.enable_fba ? 1 : 0,
          normal_inspect_rate: item.normal_inspect_rate,
          careful_inspect_rate: item.careful_inspect_rate,
          label_rate: item.label_rate,
          fba_rate: item.fba_rate,
        });
      });
      this.$api.roleApi.setInspectRate(datas).then((res) => {
        this.$message.success(res.msg);
        this.getAccountNumberList();
        this.jinPinDialogVisible = false;
      });
    },
    //显示下单前缀设置
    showPrefix(item, title, type) {
      this.prefixType = type
      this.prefixTitle = title
      this.prefixData = {}
      this.$forceUpdate()
      if (type == 1) {
        this.prefixData = {
          id: item.id,
          receiver_prefix: (item.admin_order_address_model || {}).receiver_prefix,
        }
      } else {
        this.prefixData = {
          id: item.id,
          receiver_mobile: (item.admin_order_address_model || {}).receiver_mobile,
        }
      }
      console.log(this.prefixData);
      this.prefixDialogVisible = true
    },
    //下单前缀设置
    setAutoOrderPrefixAndMobile() {
      this.$api.roleApi.setAutoOrderPrefixAndMobile(this.prefixData).then(res => {
        this.$message.success(res.msg)
        this.getAccountNumberList()
        this.prefixDialogVisible = false
      })
    },
    //新增人员配置
    addSetFollower() {
      this.setFollowerData.list.push({
        start_at: '',
        end_at: '',
        rate: [],
        userList: [],
      })
    },
    //设置比例
    setRate(index) {
      this.setFollowerData.list[index].rate = []
      this.setFollowerData.list[index].userList.forEach(item => {
        this.setFollowerData.list[index].rate.push({
          rate: '',
          admin_id: item
        })
      })
    },
    // 显示人员设置
    personnelConfiguration(item) {
      console.log(item);
      if (item.follow_config == null) {
        this.setFollowerData = {
          admin_id: item.id,
          list: [],
        }// 设置跟进数据
      } else {
        item.follow_config.forEach(items => {
          items.userList = []
          items.rate.forEach(rate => {
            items.userList.push(rate.admin_id - 0)
          })
        })
        // console.log(item.follow_config);
        this.setFollowerData = {
          admin_id: item.id,
          list: JSON.parse(JSON.stringify(item.follow_config,))
        }
      }
      this.personnelConfigurationDialogVisible = true
    },
    // 获取名称
    getName(id) {
      let itemData = this.y.find(item => item.id == id)
      return itemData ? itemData.realname : ''
    },
    // 设置跟进人员
    setFollower() {
      for (let i = 0; i < this.setFollowerData.list.length; i++) {
        if (this.setFollowerData.list[i].start_at == '' || this.setFollowerData.list[i].end_at == '') {
          return this.$message.error('未选择时间段')
        }
        for (let j = 0; j < this.setFollowerData.list[i].rate.length; j++) {
          if (this.setFollowerData.list[i].rate[j].rate == '') {
            return this.$message.error('未填写比例')
          }
        }
      }
      this.$api.roleApi
        .setFollower(this.setFollowerData)
        .then((res) => {
          this.$message.success(res.msg);
          this.getAccountNumberList();
          this.personnelConfigurationDialogVisible = false;
        });
    },
    //查看CW
    specialGroupAddition(row) {
      this.bindFoundRelationData = {
        admin_id: row.id,
        relevance: row.cw_relevance,
      }
      this.specialGroupAdditionDialogVisible = true
    },
    //绑定cw特殊加群
    bindFoundRelation() {
      this.$api.noticeApi.bindFoundRelation(this.bindFoundRelationData).then((res) => {
        this.$message.success(res.msg);
        this.accountNumberList.forEach(item => {
          if (item.id == this.bindFoundRelationData.admin_id) {
            item.cw_relevance = this.bindFoundRelationData.relevance
          }
        })
        this.$forceUpdate()
        this.specialGroupAdditionDialogVisible = false
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.default-sealer {
  margin-top: 6px;
  color: #2c96e7;
}

section {
  border-radius: 8px;
  background: #f8f8f8;
  display: flex;
  flex-direction: column;
  padding: 24px;

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .operationContainer {
    .operationLeftContainer {
      div {
        width: 180px;
        margin-right: 24px;
      }
    }
  }

  .table {
    margin-top: 24px;
  }
}

.label {
  margin-bottom: 20px;
}

.row {
  margin-bottom: 10px;
  display: flex;

  .label {
    width: 150px;
    line-height: 40px;
    margin: 0px;
  }

  .items {
    flex: 1;
    margin-right: 15px;

    &:nth-last-child(1) {
      margin: 0;
    }
  }
}

.btn {
  text-align: right;
  margin: 10px 0 0;
}

.table {
  .flex2 {
    flex: 2;



    /deep/.el-select {
      width: 95%;
    }
  }

  .rate {


    .row {
      position: relative;
      height: 40px;

      &:nth-last-child(1) {
        margin-bottom: 0;
      }

      .name {
        line-height: 40px;
        margin-right: 10px;
      }

      span {
        position: absolute;
        top: 10px;
        right: 45px;
        z-index: 99;
      }
    }
  }
}

.forbidLoginData {
  padding: 0 20px;

  .text {
    max-height: 500px;
    overflow-y: auto;

    p {
      color: red;
      font-size: 16px;
    }
  }
}
</style>
